export default {
  readers: [
    'DrillingReaders',
    'DrillingWriters',
    'DrillingAdmin',
    'Admin'
  ],
  collaborators: [
    'DrillingWriters',
    'DrillingAdmin',
    'Admin'
  ],
  admins: [
    'DrillingAdmin',
    'Admin'
  ]
}
